export default __webpack_public_path__ + "static/media/astronaut.a9f51fe9.svg";